import ColorStyles from '@components/ColorStyles';
import BrDropdownMenu from './BrDropdownMenu';

BrDropdownMenu.ColorStyles = ColorStyles;
export default BrDropdownMenu;
